import { paths } from '@/constants/paths'
import { getBasicPageMetaData, Seo } from '@/layout/Seo'
import { NextPageWithLayout } from '@/layouts'
import { CollectiblesLayout } from '@/layouts/CollectiblesLayout'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { CollectiblesView } from '@/views/CollectiblesViews'

interface CollectiblesLandingProps {
  locale: string
}

export const CollectiblesLanding: NextPageWithLayout<CollectiblesLandingProps> = ({ locale }) => {
  const { t } = useTranslate('collectibles')

  const title = t('angelCollectibleScenes', 'Angel Collectible Scenes')
  const description = t(
    'ownADigitalFrame',
    'Own a digital frame of your favorite shows and movies from Angel Studios and help support future shows.',
  )

  return (
    <>
      <Seo
        {...getBasicPageMetaData({
          locale,
          path: paths.collectiblesMarketplace.index,
          title,
          description,
          cloudinaryImagePath: 'v1709163115/angel-studios/open-graph-240228.jpg',
          cloudinaryTransformation: '',
        })}
        noindex
        nofollow
      />
      <div className="bg-gray-100 py-8">
        <CollectiblesView />
      </div>
    </>
  )
}

export const getStaticProps = getStaticPropsErrorHandler<CollectiblesLandingProps>(
  { filePath: 'pages/[locale]/collectibles/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'collectibles'])),
      },
    }
  },
)

export const getStaticPaths = getGenericStaticPaths

CollectiblesLanding.getLayout = (page) => {
  return <CollectiblesLayout isDarkMode={false}>{page}</CollectiblesLayout>
}

export default CollectiblesLanding
